// /client/customer/src/utils/reservation/by-service/fetchServicesForServiceReserve.ts
import apiConfig from '../../../apiConfig';

export type ServiceForServiceReserve = {
  service_id: number;
  service_name: string;

  // 共通ルール：金額は小数点2桁（numberで扱う）
  price: number;

  // 分（number）
  duration_minutes: number;

  // カテゴリはNULLあり得る
  category_id: number | null;
  category_name: string | null;
  color_class: string | null;
};

export type FetchServicesForServiceReserveResponse = {
  services: ServiceForServiceReserve[];
};

// 安全に number 化（DECIMAL文字列が来ても耐える）
const toNumberSafe = (v: unknown): number => {
  const n = Number(String(v ?? '').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

export const fetchServicesForServiceReserve = async (
  storeId: number,
): Promise<ServiceForServiceReserve[]> => {
  if (!Number.isFinite(storeId) || storeId <= 0) {
    throw new Error('Invalid storeId');
  }

  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-service/services`);
  url.searchParams.set('store_id', String(storeId));

  const res = await fetch(url.toString(), { method: 'GET' });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as any).error || 'Failed to fetch services');
  }

  const data = (await res.json()) as FetchServicesForServiceReserveResponse;
  const list = Array.isArray(data?.services) ? data.services : [];

  // 返り値を正規化（number/nullable を強制）
  return list.map((r: any) => ({
    service_id: Number(r.service_id),
    service_name: String(r.service_name ?? ''),

    // 2桁に丸めて number で保持（表示は money() で 2桁）
    price: Number(toNumberSafe(r.price).toFixed(2)),

    duration_minutes: Math.max(0, Math.trunc(toNumberSafe(r.duration_minutes))),

    category_id: r.category_id == null ? null : Number(r.category_id),
    category_name: r.category_name == null ? null : String(r.category_name),
    color_class: r.color_class == null ? null : String(r.color_class),
  }));
};
